import { useState } from 'react';
import {
  FiChevronDown,
  FiChevronRight,
  FiAward,
  FiTruck,
  FiUser,
  FiSettings,
  FiMapPin,
} from 'react-icons/fi';
import { MdPeople } from 'react-icons/md';

import Logo from '../../../../assets/logo2.png';

import { usePageContext } from '../../../../context/usePage';
import { useSideMenuContext } from '../../../../context/useSideMenu';
import { appCommit, appVersion } from '../../../../utils/appVersion';
import { Option } from './Option';
import {
  singleOptions,
  pqflOptions,
  visitOptions,
  collectOptions,
  managementOptions,
  tankerOptions,
  reportOptions,
} from './options';
import { ContainerMenuOptions, ExpandableSection } from './styles';

const MenuOptions = () => {
  const { selectedPage, setSelectedPage } = usePageContext();
  const { sideMenuIsOpen } = useSideMenuContext();
  const [expanded, setExpanded] = useState({
    cadastro: false,
    pqfl: false,
    visitas: false,
    coleta: false,
    tanqueiro: false,
    gerenciamento: false,
  });

  const toggleSection = (section: keyof typeof expanded) => {
    setExpanded(prev => ({ ...prev, [section]: !prev[section] }));
  };
  // useEffect(() => {
  //   if (searchedOption) {
  //     const filter = options.filter(item => {
  //       if (
  //         item
  //           .option!.normalize('NFD')
  //           .replace(/[\u0300-\u036f]/g, '')
  //           .toLocaleLowerCase()
  //           .includes(
  //             searchedOption
  //               .normalize('NFD')
  //               .replace(/[\u0300-\u036f]/g, '')
  //               .toLocaleLowerCase(),
  //           ) === true
  //       ) {
  //         if (
  //           item
  //             .option!.normalize('NFD')
  //             .replace(/[\u0300-\u036f]/g, '')
  //             .toLocaleLowerCase()
  //             .indexOf(
  //               searchedOption
  //                 .normalize('NFD')
  //                 .replace(/[\u0300-\u036f]/g, '')
  //                 .toLocaleLowerCase(),
  //             ) > -1
  //         ) {
  //           return true;
  //         }
  //         return false;
  //       }
  //       return false;
  //     });

  //     setListenedOption(filter);
  //   } else {
  //     setListenedOption(options);
  //   }
  // }, [searchedOption]);

  return (
    <ContainerMenuOptions sideMenuIsClose={sideMenuIsOpen}>
      <div className="menu-logo-container">
        <img src={Logo} alt="Meta Collect Logo" />
        <span className="menu-version" title={`Commit ${appCommit}`}>
          Versão {appVersion}
        </span>
      </div>
      {reportOptions.map((item, index) => {
        const { option, title, toPath } = item;
        return (
          <Option
            key={index}
            action={() => setSelectedPage({ option })}
            option={option}
            title={title}
            toPath={toPath}
            selected={selectedPage}
          />
        );
      })}

      <div
        className={`option-separator ${!expanded.cadastro ? 'collapsed' : ''}`}
        onClick={() => toggleSection('cadastro')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MdPeople size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>Cadastro</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.cadastro ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.cadastro}>
        <div>
          {singleOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>

      <div
        className={`option-separator ${!expanded.visitas ? 'collapsed' : ''}`}
        onClick={() => toggleSection('visitas')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiMapPin size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>Visitas</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.visitas ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.visitas}>
        <div>
          {visitOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>

      <div
        className={`option-separator ${!expanded.pqfl ? 'collapsed' : ''}`}
        onClick={() => toggleSection('pqfl')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiAward size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>PQFL</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.pqfl ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.pqfl}>
        <div>
          {pqflOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>

      <div
        className={`option-separator ${!expanded.coleta ? 'collapsed' : ''}`}
        onClick={() => toggleSection('coleta')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiTruck size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>Coleta</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.coleta ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.coleta}>
        <div>
          {collectOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>

      <div
        className={`option-separator ${!expanded.tanqueiro ? 'collapsed' : ''}`}
        onClick={() => toggleSection('tanqueiro')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiUser size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>Tanqueiro</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.tanqueiro ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.tanqueiro}>
        <div>
          {tankerOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>

      <div
        className={`option-separator ${
          !expanded.gerenciamento ? 'collapsed' : ''
        }`}
        onClick={() => toggleSection('gerenciamento')}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiSettings size={sideMenuIsOpen ? 24 : 18} />
          {!sideMenuIsOpen && <h3>Configuração</h3>}
        </div>
        {!sideMenuIsOpen &&
          (expanded.gerenciamento ? <FiChevronDown /> : <FiChevronRight />)}
      </div>

      <ExpandableSection $isExpanded={expanded.gerenciamento}>
        <div>
          {managementOptions.map((item, index) => {
            const { option, title, toPath } = item;
            return (
              <Option
                key={index}
                action={() => setSelectedPage({ option })}
                option={option}
                title={title}
                toPath={toPath}
                selected={selectedPage}
              />
            );
          })}
        </div>
      </ExpandableSection>
    </ContainerMenuOptions>
  );
};

export { MenuOptions };
